<template>
  <div>
    <!-- category数据渲染 -->
    <!-- <div class="div">
      <el-row>
        <a
          href="###"
          :class="{ anchor: true, active: i == active }"
          v-for="(item, i) in goodsCategory"
          :key="item.id"
          @click="fun(i)"
        >
          {{ item.name }}
        </a>
      </el-row>
    </div> -->
    <div
      class="div"
      v-for="(item, index) in goodsCategory"
      v-show="active == index"
      :key="item.id"
    >
      <!-- <h1 class="red">{{ item.name }} | {{ item.title }}</h1> -->
      <div
        class="container"
        v-for="(item1, i) in item.list"
        :key="item1.id"
        v-show="item1.data.list.length != 0"
      >
        <div class="divRed" >
          <!-- <span class="spanRed">&nbsp;</span>
          <span>{{ item1.name }}</span> -->
      <h1 class="red">{{ item1.name }} </h1>

          <div class="gridBox">
          <div class="children" v-for="(item2, i) in item1.data.list" :key="i">
            
            <div class="img" @click="viewDetail(item2)">
              
                <img :src="item2.pic" />
                <div class="one"></div>
                <div class="two" v-html="delHtmlTag(item2.name)">
                  {{ item2.name }}
                </div>
            </div>
          </div>
        </div>

          
        </div>
        
        <el-pagination
          @current-change="handleCurrentChange($event, i, index)"
          small
          layout="pager"
          :total="item1.data.total"
          :page-size="pageSize"
          v-show="item1.data.total > pageSize"
          :current-page="num"
        >
          <!--:current-page.sync="num"修饰符在属性的最后面.xxxx-->
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "DaotTwo",
  data() {
    return {
      dataList: [1, 2, 3, 4],
      isActive: "",
      dataTlist: [1, 2, 3, 4, 5, 6],
      liList: [1, 2, 3, 4, 5],
      goodsCategory: {},
      pageSize: 8,
      active: 0,
      //默认在第一页
      num: 1,
    };
  },
  methods: {
    viewDetail(productInfo){
      const routeData = this.$router.resolve({
          path:'/productDetail',query:{'id':productInfo.id}
        });
        window.open(routeData.href, "_blank");
        window.localStorage.setItem('productdetail', JSON.stringify(productInfo));
    },
    delHtmlTag(str) {
      if (str != null) {
        return str.replace(/<[^>]+>/g, "");
      }
    },
    fun(i) {
      (this.active = i), this.getGoodsCategory();
      this.num = 1;
      //每次dom渲染完放入页面,才会执行里面的代码
      this.$nextTick(() => {
        this.num = null;
      });
    },
    async getGoodsCategory() {
      this.goodsCategory = (
        await axios({
          method: "get",
          // url: "/xm/index.php/index/index/getGoodsCategory",
          url: "https://www.jianongzhenghe.com/index.php/index/index/getGoodsCategory",
          params: {
            page: 1, //第几页数据
            limit: this.pageSize, // 一页多少个数据
          },
        })
      ).data.data;
      console.log(this.goodsCategory);
    },

    //分页组件的页数一旦改变，就执行这个函数
    async handleCurrentChange(newCurrent, i, index) {
      //应该放这里验证，看看你改变页码对num有没有效
      // console.log(this.num+"num");
      this.goodsCategory[index].list[i].data = (
        await axios({
          method: "get",
          // url: "/xm/index.php/index/index/getGoodsCategory",
          url: "https://www.jianongzhenghe.com/index.php/index/index/getGoodsCategory",
          params: {
            page: newCurrent, //第几页数据
            limit: this.pageSize, // 一页多少个数据
          },
        })
      ).data.data[index].list[i].data;
      // console.log(this.goodsCategory);
      // console.log(newCurrent);
    },
  },
  created() {
    // 默认获取第一页
    this.getGoodsCategory();
  },
};
</script>

<style scoped lang="less">
/deep/.el-tabs__nav-wrap::after {
  background-color: red;
  width: 50% !important;
}
/deep/ .el-row {
  text-align: center;
  .anchor {
    display: inline-block;
    width: 7.8125vw;
    height: 3.125vw;
    border: 0.0521vw solid #d5d5d5;
    margin: 0 1.0417vw;
    text-align: center;
    line-height: 3.125vw;
    border-radius: 1.0417vw;
    color: #838383;
  }
  .active {
    background-color: #1EA364;
    color: #fbefef !important;
  }
}
.win {
  width: 21vw;
  height: 32vw;
  // background-color: pink;
  border: 0.1042vw solid #e8e8e8;
  margin-right: 1vw;

  .img {
    // width: 95%;
    height: 80%;
    // background-color: black;
    img {
      width: 100%;
      height: 100%;
      // background-color: rgb(150, 48, 48);
    }
  }
  .one {
    position: absolute;
    bottom: 16.5%;
    left: 1.5625vw;
    width: 2.0833vw;
    height: 0.3563vw;
    background-color: red;
  }
  .two {
    position: absolute;
    left: 1.5625vw;
    // bottom: 2vw;
    margin-top: 1.5vw;
    font-size: 1vw;
  }
}
/deep/.gridBox {
  margin-left: 9vw;
  width: 88.5417vw;
  min-height: 14.2vw;
  display: flex;
  flex-wrap: wrap;
}
// 24.5417vw
.children1{
  width: 15.6vw;
  height: 15.6vw;
}
/deep/ .children:nth-child(n) {
  width: 15.6vw;
  margin: 20px;
  height: 15.6vw;
  position: relative;
  border: 0.1042vw solid #e8e8e8;
  .img {
    width: 100%;
    height: 80%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .one {
    position: absolute;
    bottom: 3.0417vw;
    left: 1.5625vw;
    width: 2.0833vw;
    height: 0.3563vw;
    background-color: red;
  }
  .two {
    position: absolute;
    left: 1.5625vw;
    // bottom: 1.0417vw;
    margin-top: 0.5vw;
    font-size: 1vw;
    width: 14vw;
  }
}
// /deep/ .children:first-child {
//     grid-row-start: span 2;
//     background-color: pink;
// }
/deep/ .el-pager {
  .number {
    margin: 0 0.5208vw;
    border-radius: 100%;
    color: #000000;
    border: 0.0521vw solid #d8d8d8;
    font-weight: 400;
  }
  .active {
    color: #fae9e9;
    background-color: #1EA364;
  }
}

/deep/ .div {
  padding-left: 5.2083vw;
  padding-right: 5.2083vw;
  .container {
    margin-bottom: 7.8125vw;
    position: relative;
    .el-pagination {
      position: absolute;
      right: 0;
      bottom: -2.6042vw;
      li:last-child {
        border-color: #e3e3e3;
      }
    }
  }
  .divRed {
    margin-bottom: 1.5625vw;
  }
  .red {
    width: 22.8333vw;
    height: 3.125vw;
    background-image: url("./images/red.png");
    background-size: 100% 100%;
    margin: 3.6458vw 0;
    line-height: 3.125vw;
    padding-left: 1.0417vw;
    color: white !important;
  }
  .spanRed {
    width: 0.4167vw;
    height: 2.0833vw;
    background-color: red;
    color: red;
  }
  span {
    width: 100%;
  }
  .divA {
    display: flex;
    justify-content: space-between;
    height: 31.25vw;
    position: relative;
    .el-pagination {
      position: absolute;
      right: 0;
      bottom: -2.6042vw;
    }

    .l {
      width: 20.8333vw;
      height: 31.25vw;
      background-color: pink;
      margin-right: 1.5625vw;
    }
    .r {
      width: 57.2917vw;
      height: 31.25vw;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-content: space-between;
      li {
        width: 13.0208vw;
        height: 14.0625vw;
        border: 0.1042vw solid black;
      }
    }
  }
}
</style>
